var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('upload',{attrs:{"limit":3,"url":_vm.url,"size":_vm.size,"auth":_vm.auth},model:{value:(_vm.urlArr),callback:function ($$v) {_vm.urlArr=$$v},expression:"urlArr"}},[_c('el-button',{attrs:{"type":"primary"}},[_vm._v("主要按钮")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-107d20d1","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/a.vue
// module id = null
// module chunks = 